module.exports = __webpack_public_path__ + "static/img/terminalIllegal_pic04.7ac946d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/terminalIllegal/terminalIllegal_pic04.png
// module id = 596
// module chunks = 1